import config from '../../config'
import { IAxiosSuccess } from '../interface'
import server from '../axiosInstance'
import { CommonConfigNameType, LocationIPSucType } from '../types/common'
import { ContentType } from '../header'
import { filterDataEmpty, getSignedData, getTimestamp, randomNum } from '../utils'

const { transponderURL, baseURL, baseSecret } = config

export const getIPInfo = (): Promise<IAxiosSuccess<LocationIPSucType>> => {
  return server.request<null, IAxiosSuccess<LocationIPSucType>>({
    url: `${transponderURL}/v3/local/ip`,
    method: 'GET',
    headers: {
      'Content-Type': ContentType.TEXT
    }
  })
}

/**
 * 获取通用配置
 * @returns
 */
export const getCommonConfig = (name: CommonConfigNameType): Promise<IAxiosSuccess<any>> => {
  const params = Object.assign({}, {
    appId: 1004,
    sign: '',
    random: randomNum(6),
    timestamp: getTimestamp()
  })
  params.sign = getSignedData(params, baseSecret)
  filterDataEmpty(params)
  return server.request<null, IAxiosSuccess<any>>({
    url: `${baseURL}/v1/comment/config/get`,
    method: 'GET',
    headers: {
      'Content-Type': ContentType.JSON
    },
    params: { ...params, name }
  })
}
